const USERS_STORAGE_KEY = 'users';

export const getStoredUsers = () => {
  try {
    if (typeof window === 'undefined') return [];
    const raw = window.localStorage.getItem(USERS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(Boolean);
  } catch {
    return [];
  }
};

export const setStoredUsers = (users) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(USERS_STORAGE_KEY, JSON.stringify((users || []).filter(Boolean)));
};

export const addStoredUser = (user) => {
  const users = getStoredUsers();
  const next = [...users, user];
  setStoredUsers(next);
  return next;
};

export const deleteStoredUser = (userId) => {
  const users = getStoredUsers();
  const next = users.filter(u => u?.id !== userId);
  setStoredUsers(next);
  return next;
};

// Helper function to authenticate user
export const authenticateUser = (username, password) => {
  const users = getStoredUsers();
  return users.find(user => user.username === username && user.password === password);
};
